export default import.meta.ROLLDOWN_FILE_URL_rQywQMxi0Kin8YoQmFMnXQ